export default {
    environment: 'online',     //debug or online
    api: {
        url: 'https://api.times.yourhr.com.cn',
        websocket: 'ws://203.195.255.81:57892'
    }
}



// WEBPACK FOOTER //
// ./.config.js